<!-- 首页 -->
<template>
  <div class="cet-index">
    <HeaderTop :subNavList="subNavList" @showYearBox="showYearBox" @sendCatalog="receiveCatalog" />
    <div v-show="selectedSubNav === 0">
      <!-- 轮播 -->
      <Banner :examType="25" :bannerList="bannerList" />
      <!-- 金刚区域 -->
      <CustomButton :examType="advertCode.year" :iconLists="iconLists" />
      <!-- 首页胶囊区 -->
      <Advertisement :examType="advertCode.year" :advertLists="advertLists" :advertisement="advertisement" />
      <!-- 直播公开课 -->
      <RecentLiveCourse
        ref="liveCours"
        :classCode="advertCode.code"
        @openLive="openLive"
        @showRemindBox="showRemindBox"
        :examType="advertCode.year"
      />
      <!-- 热销课程榜单 -->
      <HotSaleCourse :hotSaleId="advertCode.hotSaleCourseId" :pageName="advertCode.year" />
      <!-- 考研咨询专区 -->
      <postgraduateChat
        v-show="postgraduateChatList.length"
        :postgraduateChatList="postgraduateChatList"
      />
      <!-- 优惠券抢购专区 -->
      <HomeCoupon :examType="advertCode.year" :couponadvertList="couponadvertList" />
      <!-- 精选课程 -->
      <HotCourse ref="hotCourse" :examSeason="advertCode.year" />
    </div>

    <!-- 专业课课程列表 -->
    <div v-if="selectedSubNav !== 0 && courseTabDetails.showType !== 7" class="courseCard">
      <CourseCard v-if="isCourseCard" :courseTabDetails="courseTabDetails" />
    </div>
    <webview v-if="courseTabDetails.showType === 7" :courseTabDetails="courseTabDetails" />

    <!-- 选择考季 -->
    <SelectType v-if="isYearTabBox" :newData="newData" @closeYearBox="closeYearBox" />
    <!-- 底部广告位 -->
    <transition name="fade">
      <Bottomadvert
        :examType="advertCode.year"
        v-show="bottomadvertList && selectedSubNav === 0 && isShowAdvert"
        :bottomadvertList="bottomadvertList"
        :bottomAreaHeight="bottomAreaHeight"
      />
    </transition>
    <!-- 悬浮聊天 -->
    <Chat />
    <!-- 首页弹窗 -->
    <HomePop :examType="25" v-if="isPopBox" @closePopBox="closePopBox" :popupData="popupData" />
    <!-- 直播弹出 -->
    <MultipleLiveCourse
      :videoList="videoList"
      :openCourseId="openCourseId"
      v-if="showLive"
      @closeLive="closeLive"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import iconList from '@/utils/iconsTypes';
import HeaderTop from '@/pages/arkHome/components/appHeaderTop.vue';
import SelectType from '@/pages/arkHome/components/selectTypes.vue';
import { reqTypeList, reqAdvertPlaying } from '@/api/home';
import { gioJumpType, gioPlatform, homeGioAdShow } from '@/utils/tools';
import Banner from '@/pages/arkHome/components/bannerVant.vue';
import CustomButton from '@/pages/arkHome/components/customButton.vue';
import Advertisement from '@/pages/exam24/components/advertisement.vue';
import RecentLiveCourse from '@/pages/arkHome/components/recentLiveCourse.vue';
import postgraduateChat from '@/pages/arkHome/components/postgraduateChat.vue';
import HotSaleCourse from '@/pages/arkHome/components/hotSaleCourse.vue';
import HomeCoupon from '@/components/homeCoupon/index.vue';
import Bottomadvert from '@/components/bottomadvert/index.vue';
import Chat from '@/pages/exam24//components/chat.vue';
import MultipleLiveCourse from '@/components/multipleLiveCourse/index.vue';
import HotCourse from '@/pages/arkHome/components/hotCourse.vue';
import CourseCard from '@/pages/arkHome/courseCard.vue';
import HomePop from '@/pages/arkHome/components/homePop.vue';
import { advertCode } from '@/utils/advertCode';
import webview from './components/webview.vue';

export default {
  data() {
    return {
      advertCode: {},
      isYearTabBox: false,
      navList: [], // 导航栏
      newData: [], // 合并图片后的数据
      subNavList: [], // 二级类目列表
      bannerList: [], // 轮播图数据
      iconLists: [], // 金刚区
      advertLists: [], // 胶囊区
      advertisement: {}, // 长图广告未
      popupData: {}, // 弹窗
      isPopBox: false,
      isRemindBox: false, // 开播提醒弹框
      videoList: [],
      openCourseId: '',
      showLive: false,
      postgraduateChatList: [], // 考研咨询专区
      selectedSubNav: 0, // 当前选中的类目
      courseTabDetails: {}, // tab詳情
      isCourseCard: false,
      courseTabArr: [], // 23考研
      isShowAdvert: true, // 是否展示广告位
      bottomadvertList: [], // 底部广告位
      couponadvertList: [], // 优惠券广告位
      bottomAreaHeight: 0,
    };
  },

  components: {
    HeaderTop,
    SelectType,
    Banner,
    CustomButton,
    Advertisement,
    RecentLiveCourse,
    postgraduateChat,
    HotSaleCourse,
    HomeCoupon,
    Bottomadvert,
    Chat,
    MultipleLiveCourse,
    HotCourse,
    CourseCard,
    HomePop,
    webview,
  },
  watch: {
    courseTabDetails: {
      handler(val) {
        this.isCourseCard = false;
        this.$nextTick(() => {
          this.isCourseCard = true;
          this.courseTabDetails = val;
        });
      },
    },
  },
  computed: {
    ...mapState(['currentYear', 'userInfo']),
  },
  created() {
    const { code } = this.$route.query;
    this.advertCode = advertCode.find((item) => Number(item.code) === Number(code));
  },
  mounted() {
    this.showSelectedSubNav();
    this.getTypeList();

    document.title = '启航教育';
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    sessionStorage.removeItem('fromPageUrl'); // 清除referer记录，提交订单接口用referer
  },
  destroyed() {},
  methods: {
    ...mapActions(['setcurrentyear']),
    // 请求广告位
    async getBanner() {
      const {
        homePopupCode,
        bannerCode,
        customButtonCode,
        bigAdvertCode,
        smallAdvertCode,
        openLiveCode,
        postgraduateChatCode,
        limtiCouponCode,
        bottomFloatCode,
      } = this.advertCode;
      const paramsList = [
        homePopupCode,
        bannerCode,
        customButtonCode,
        bigAdvertCode,
        smallAdvertCode,
        openLiveCode,
        postgraduateChatCode,
        limtiCouponCode,
        bottomFloatCode,
      ];
      const res = await reqAdvertPlaying(paramsList);
      if (res.code === 0) {
        // 首页banner
        this.bannerList = res.data?.find(
          (item) => item.adCode === bannerCode,
        )?.advertisingContentWebInfoRespVOS;
        // 请求金刚区
        this.iconLists = res.data?.find(
          (item) => item.adCode === customButtonCode,
        )?.advertisingContentWebInfoRespVOS;
        // 请求胶囊区
        this.advertLists = res.data?.find(
          (item) => item.adCode === smallAdvertCode,
        )?.advertisingContentWebInfoRespVOS;
        // 短胶囊最多展示两个，取sort 最大的两个
        if (this?.advertLists?.length > 2) {
          this.advertLists = this.advertLists.slice(0, 2);
        }
        // 首页长图广告位
        this.advertisement = res.data?.find(
          (item) => item.adCode === bigAdvertCode,
        )?.advertisingContentWebInfoRespVOS[0];
        // 首页考研咨询广告位
        this.postgraduateChatList =
          res.data?.find((item) => item.adCode === postgraduateChatCode)
            ?.advertisingContentWebInfoRespVOS || [];
        // 首页优惠券广告位
        this.couponadvertList = res.data?.find(
          (item) => item.adCode === limtiCouponCode,
        )?.advertisingContentWebInfoRespVOS;
        if (this.couponadvertList && !this.$root.$data.isApp) {
          this.couponadvertList[0].adPosition_var = `${this.advertCode.year}考研-首页-优惠券广告`;
          homeGioAdShow(this.couponadvertList);
        }
        // 首页底部广告位
        this.bottomadvertList = res.data?.find(
          (item) => item.adCode === bottomFloatCode,
        )?.advertisingContentWebInfoRespVOS;
        if (this.bottomadvertList && !this.$root.$data.isApp) {
          this.bottomadvertList[0].adPosition_var = `${this.advertCode.year}考研-首页-底部广告`;
          homeGioAdShow(this.bottomadvertList);
        }
        // 首页弹窗
        this.popupData = res.data?.find(
          (item) => item.adCode === homePopupCode,
        )?.advertisingContentWebInfoRespVOS[0];
        if (this.popupData) {
          if (!this.$root.$data.isApp) {
            this.isPopBox = true;
            this.gioEvent((this.gioType = 1));
          }

          if (sessionStorage.getItem('HomePopup25')) {
            this.isPopBox = false;
          }
        }
      }
    },
    async getTypeList() {
      const res = await reqTypeList('HOME_EXAM_CONFIG_H5');
      if (res.code === 0) {
        this.navList = res.data;
        const remark = this.navList.find((item) => item.code === this.advertCode.code)?.remark;
        this.courseTabArr = JSON.parse(remark);
        this.subNavList = JSON.parse(remark || '{}');
        this.subNavList.unshift({ id: 0, name: '精选' });
        this.getBanner();
        this.navList.map((item) => {
          // eslint-disable-next-line array-callback-return
          iconList.map((e) => {
            if (item.code === e.code) {
              Object.assign(item, e);
            }
          });
          return item;
        });
        this.newData = this.navList;
      }
    },

    // 显示选择年份弹框
    showYearBox() {
      this.isYearTabBox = true;
      if (this.$root.$data.isApp) {
        this.$sendToApp('hideBottomSidebar');
      }
    },
    // 关闭选择年份弹框
    closeYearBox() {
      this.isYearTabBox = false;
      // App显示底部导航
      if (this.$root.$data.isApp) {
        this.$sendToApp('showBottomSidebar');
      }
    },

    async getLoginAfter() {
      await this.$root.getUserInfo();
      setTimeout(() => {
        this.getTypeList();
      }, 500);
      await this.$refs.hotCourse.getRecommend();
      await this.$refs.liveCours.getOpenCourse();
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    receiveCatalog(data) {
      this.selectedSubNav = data.index;
      if (data.index === 0) {
        setTimeout(() => {
          this.getTypeList();
        }, 500);
      } else {
        this.courseTabDetails = this.courseTabArr[data.index - 1];
        sessionStorage.setItem('courseTabDetails', JSON.stringify(this.courseTabDetails));
      }
    },
    closeLive() {
      this.showLive = false;
    },
    openLive(data) {
      this.videoList = data.videoList;
      this.openCourseId = data.openCourseRecordId;
      this.showLive = true;
    },
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    // touchMove(evt) {
    //   try {
    //     const touch = evt.touches[0]; // 获取第一个触点
    //     // x = Number(touch.pageX), //页面触点X坐标
    //     const y = Number(touch.pageY); // 页面触点Y坐标
    //     // 判断滑动方向
    //     if (y - this.startY < 0) {
    //       this.isShowAdvert = false;
    //     } else {
    //       this.isShowAdvert = true;
    //     }
    //   } catch (e) {
    //     console.log(e.message);
    //   }
    // },
    // 滑动
    // touchStart(evt) {
    //   try {
    //     const touch = evt.touches[0]; // 获取第一个触点
    //     const x = Number(touch.pageX); // 页面触点X坐标
    //     const y = Number(touch.pageY); // 页面触点Y坐标
    //     // 记录触点初始位置
    //     this.startX = x;
    //     this.startY = y;
    //   } catch (e) {}
    // },
    // // 绑定事件
    // bindEvent() {
    //   document.addEventListener('touchstart', _.debounce(this.touchStart, 300, true), false);
    //   document.addEventListener('touchmove', _.debounce(this.touchMove, 300, true), false);
    // },
    gioEvent(type) {
      const { title, skipType } = this.popupData;
      const adId = this.popupData.id;
      if (type === 2) {
        // 关闭广告埋点
        // eslint-disable-next-line
        gio('track', 'adClose_event', {
          adPosition_var: `${this.advertCode.year}考研-首页-弹窗`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: `${this.advertCode.year}考研-首页-弹窗`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
    closePopBox() {
      this.isPopBox = false;
      // 存session 控制弹窗
      sessionStorage.setItem('HomePopup25', true);
      this.gioEvent((this.gioType = 2));
    },
    showSelectedSubNav() {
      // 从学姐详情返回需要定位到学长学姐tab
      const show = sessionStorage.getItem('SeniorDetail');
      const courseTabDetails = sessionStorage.getItem('courseTabDetails');
      if (show) {
        this.selectedSubNav = -1;
        this.courseTabDetails = JSON.parse(courseTabDetails);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cet-index {
  width: 100%;
  min-height: 100vh;
  padding: 200px 0 20px 0;
  background: #fefeff;
  ::v-deep .sub-nav {
    margin: 0 0 30px 0;
  }
}
.course-list {
  position: relative;
  padding: 0 40px;
}

::v-deep .van-loading {
  margin: 100px 0;
  text-align: center;
}
.courseCard {
  padding: 0 40px;
}
</style>
